/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Edit_ResourceInputs */

const en_admin_resources_edit_resource = /** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Resource`)
};

const de_admin_resources_edit_resource = /** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressource bearbeiten`)
};

const es_admin_resources_edit_resource = /** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar recurso`)
};

const fr_admin_resources_edit_resource = /** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la ressource`)
};

const nl_admin_resources_edit_resource = /** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorziening bewerken`)
};

/** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */
const it_admin_resources_edit_resource = en_admin_resources_edit_resource;

/** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */
const pt_br2_admin_resources_edit_resource = en_admin_resources_edit_resource;

/** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */
const pl_admin_resources_edit_resource = en_admin_resources_edit_resource;

/** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */
const hu_admin_resources_edit_resource = en_admin_resources_edit_resource;

/** @type {(inputs: Admin_Resources_Edit_ResourceInputs) => LocalizedString} */
const ro_admin_resources_edit_resource = en_admin_resources_edit_resource;

/**
* | output |
* | --- |
* | "Edit Resource" |
*
* @param {Admin_Resources_Edit_ResourceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_edit_resource = /** @type {((inputs?: Admin_Resources_Edit_ResourceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Edit_ResourceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_edit_resource(inputs)
	if (locale === "de") return de_admin_resources_edit_resource(inputs)
	if (locale === "es") return es_admin_resources_edit_resource(inputs)
	if (locale === "fr") return fr_admin_resources_edit_resource(inputs)
	if (locale === "nl") return nl_admin_resources_edit_resource(inputs)
	if (locale === "it") return it_admin_resources_edit_resource(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_edit_resource(inputs)
	if (locale === "pl") return pl_admin_resources_edit_resource(inputs)
	if (locale === "hu") return hu_admin_resources_edit_resource(inputs)
	return ro_admin_resources_edit_resource(inputs)
});
export { admin_resources_edit_resource as "admin.resources.edit_resource" }